export default __webpack_public_path__ + "static/media/fishing.4c1ee70f.webp";